jQuery(document).ready(function ($) {
	console.log('Salut')
	$(".expand-btn").on("click", function () {
		var $card = $(this).closest(".card"); // Trouver l'article parent
		var $answerContent = $card.find(".content"); // Contenu à afficher/masquer
		var isOpen = $(this).attr("aria-expanded") === "true"; // Vérifier l'état actuel
		$(this).find('.expanded-label').toggleClass('hidden');

		// Basculer l'état de la carte
		$card.toggleClass("active");
		$answerContent.slideToggle(300); // Animation
		$(this).attr("aria-expanded", !isOpen); // Mise à jour de l'état du bouton
		$answerContent.attr("aria-hidden", isOpen); // Mise à jour de l'état du contenu
	});

	// Vérifier si l'URL contient une ancre
	var anchor = window.location.hash;

	if (anchor) {
		var $target = $(anchor);
		if ($target.length) {
			var $card = $target.closest(".card"); // Trouver l'article correspondant
			var $button = $card.find(".expand-btn"); // Bouton associé

			// Ouvrir la carte
			$card.addClass("active");
			$card.find(".content").slideDown(300).attr("aria-hidden", "false");
			$button.attr("aria-expanded", "true");

			// Défilement jusqu'à la carte
			$("html, body").animate(
				{
					scrollTop: $card.offset().top,
				},
				500
			);
		}
	}

	// Ajouter un événement pour la touche "Escape"
	$(document).keydown(function (event) {
		if (event.key === "Escape") {
			// Fermer toutes les FAQ ouvertes
			$(".card.active").each(function () {
				var $card = $(this);
				var $button = $card.find(".expand-btn");
				var $answerContent = $card.find(".content");

				// Mettre à jour les états
				$card.removeClass("active");
				$button.attr("aria-expanded", "false");
				$answerContent.slideUp(300).attr("aria-hidden", "true");
			});
		}
	});
});
